







import { Component, Vue } from "vue-property-decorator";
import { GetUserInfo } from "@/request/common";

@Component({})
export default class App extends Vue {
  private configPath = "D:/TCMALL/hnsz.config";
  private electronAPI: any = null;
  private isDesktop: boolean = false;
  private loading: boolean = true;

  // 封装白名单字段合并逻辑
  private mergeConfigFields(curData: any, localConfig: any) {
    let target = JSON.parse(JSON.stringify(curData));
    if (localConfig.API_ROOT && target.GLOBAL_API_ROOT) {
      target.GLOBAL_API_ROOT = localConfig.API_ROOT;
    }
    if (localConfig.name && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.name = localConfig.name;
    }
    if (localConfig.logo && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.logo = localConfig.logo;
    }
    if (localConfig.favicon_url && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.favicon_url = localConfig.favicon_url;
    }
    if (localConfig.mode && target.SETTING) {
      target.SETTING.mode = localConfig.mode;
    }

    if (localConfig.ifVerifyLight !== undefined && target.SETTING) {
      target.SETTING.ifVerifyLight = localConfig.ifVerifyLight;
    }
    if (localConfig.ifVerifyLight !== undefined && target.SETTING) {
      target.SETTING.ziWaiLight = localConfig.ziWaiLight;
    }
    if (localConfig.ifVerify !== undefined && target.SETTING) {
      target.SETTING.ifVerify = localConfig.ifVerify;
    }
    if (localConfig.ifShowLogo !== undefined && target.SETTING) {
      target.SETTING.ifShowLogo = localConfig.ifShowLogo;
    }
    if (localConfig.ifShowLoginBg !== undefined && target.SETTING) {
      target.SETTING.ifShowLoginBg = localConfig.ifShowLoginBg;
    }
    if (localConfig.ifAutoUpdate !== undefined && target.SETTING) {
      target.SETTING.ifAutoUpdate = localConfig.ifAutoUpdate;
    }
    if (localConfig.ifPushToSaaS !== undefined && target.SETTING) {
      target.SETTING.ifPushToSaaS = localConfig.ifPushToSaaS;
    }

    return target;
  }

  private async updateConfig(data: any) {
    let obj = data;
    this.updateData(obj);
    if (this.isDesktop) {
      console.log("this.isDesktop", this.isDesktop);
      try {
        if (this.electronAPI) {
          this.electronAPI
            .readConfigFile(this.configPath)
            .then((localConfig: any) => {
              if (localConfig) {
                const target = this.mergeConfigFields(obj, localConfig);
                this.updateData(target);
              }
            });
        } else {
        }
      } catch (error) { }
    } else {
      try {
        const globalName = await this.fetchGlobalName();
        console.log("globalName", globalName);
        const globalConfig = await this.fetchGlobalConfig(globalName);
        this.updateData(globalConfig);
      } catch (error) {
        console.log("获取全局配置失败", error);
      }
    }
  }
  private updateData(d: any) {
    // 把SYSTEM_MSG放到第一层，这是为了兼容通过id拿项目信息
    d = { ...d, ...d.SYSTEM_MSG };

    // 检测外部资源替换 (仅在桌面端有效)
    if (this.isDesktop && this.electronAPI && this.electronAPI.readLocalImage) {
      const assetsPath = 'D:\\TCMALL\\assets\\';

      // 1. 处理 Logo (文件名约定: logo.png)
      const extLogo = this.electronAPI.readLocalImage(assetsPath + 'logo.png');
      if (extLogo) {
        d.logo = 'data:image/png;base64,' + extLogo;
      }

      // 2. 处理 登录背景 (文件名约定: login_bg.jpg)
      const extBg = this.electronAPI.readLocalImage(assetsPath + 'login_bg.jpg');
      if (extBg) {
        d.customLoginBg = 'data:image/jpeg;base64,' + extBg;
      }

      // 3. 处理 首页Banner (文件名约定: banner_1.jpg 到 banner_5.jpg)
      d.customBanners = [];
      for (let i = 1; i <= 5; i++) {
        const bImg = this.electronAPI.readLocalImage(assetsPath + 'banner_' + i + '.jpg');
        if (bImg) {
          d.customBanners.push('data:image/jpeg;base64,' + bImg);
        }
      }
    }
    // 修改项目名称
    document.title = d.name;
    // 修改项目 icon
    try {
      let link: any = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = d.logo;
      } else {
        var newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = d.logo;
        newLink.type = "image/x-icon";
        document.head.appendChild(newLink);
      }
    } catch (error) { }


    console.log("last-SystemInfo", d);
    this.$store.commit("updateSystemInfo", d);
  }

  // 新增：动态获取 global.js 名称，兼容变量赋值
  private async fetchGlobalName(): Promise<string> {
    if (this.isDesktop) {
      // 桌面端用 electronAPI 读取（asar 包根目录下）
      const text = await this.electronAPI.readFile("global.js");
      const codeWithoutComments = text.replace(/\/\/.*$/gm, "").trim();
      const match = codeWithoutComments.match(
        /(?:module\.exports\s*=\s*['"](.+?)['"]|const\s+defaultConfigName\s*=\s*['"](.+?)['"])/
      );
      if (match) {
        return match[1] || match[2];
      }
      return "";
    } else {
      // 网页端用 fetch
      const res = await fetch("/global.js?" + Date.now());
      if (!res.ok) return "";
      const text = await res.text();
      const codeWithoutComments = text.replace(/\/\/.*$/gm, "").trim();
      const match = codeWithoutComments.match(
        /(?:module\.exports\s*=\s*['"](.+?)['"]|const\s+defaultConfigName\s*=\s*['"](.+?)['"])/
      );
      if (match) {
        return match[1] || match[2];
      }
      return "";
    }
  }

  // 新增：动态获取 global-xxx.js 配置
  private async fetchGlobalConfig(globalName: string): Promise<any> {
    if (this.isDesktop) {
      // 桌面端用 electronAPI 读取
      const text = await this.electronAPI.readFile(`global/${globalName}.js`);
      const match = text.match(/module\.exports\s*=\s*({[\s\S]*});?/);
      if (match) {
        // eslint-disable-next-line no-new-func
        return new Function("return " + match[1])();
      }
      return {};
    } else {
      // 网页端用 fetch
      const res = await fetch(`/global/${globalName}.js?` + Date.now());
      const text = await res.text();
      const match = text.match(/module\.exports\s*=\s*({[\s\S]*});?/);
      if (match) {
        // eslint-disable-next-line no-new-func
        return new Function("return " + match[1])();
      }
      return {};
    }
  }
  private created() {
    const globalConfig = require("../public/global.js"); // 读取 global.js
    // 读取特定配置文件
    let Global = require(`../public/global/${globalConfig}.js`);
    this.isDesktop = !!(Global.SETTING && Global.SETTING.ifDesktop);
    if (this.isDesktop) {
      // // 获取 electron API
      if (window && (window as any).electronMyAPI) {
        try {
          this.electronAPI = (window as any).electronMyAPI;
        } catch (error) { }
      }
    }
    let state = sessionStorage.getItem("state");
    if (state) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(state))
      );
      sessionStorage.removeItem("state");
    }
    // 添加页面卸载前保存 state 的事件监听器
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
  }
  private async mounted() {
    try {
      const globalName = await this.fetchGlobalName();
      const globalConfig = await this.fetchGlobalConfig(globalName);
      let obj: any = { ...globalConfig };
      this.updateConfig(obj);
    } catch (e) {
      console.error("mounted error", e);
    } finally {
      this.loading = false;
    }
  }
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏
    window.removeEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
  }
}
